"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexDuplicatedRule = void 0;
exports.getDuplicatedIndexes = getDuplicatedIndexes;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * Indexes are great to speed read performances, but they come at the cost of reducing write performances.
 * This is call write amplification, where writing a single row MUST update one or several indexes.
 * Most of the time this is not an issue because we read much more than we write, but still, only useful indexes should be kept.
 * This rule identify duplicated indexes, meaning they are redundant and the smallest one could be removed to speed writes without impacting reads.
 */
const ruleId = 'index-duplicated';
const ruleName = 'duplicated index';
const ruleDescription = 'indexes with all columns covered by other indexes';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributesId.array().optional()
}).strict().describe('IndexDuplicatedConf');
exports.indexDuplicatedRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.high },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && Array.isArray(r.extra?.index?.attrs) ? { ...r.entity, attrs: r.extra.index.attrs } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.attributesRefFromId) || []);
        return (db.entities || []).flatMap(getDuplicatedIndexes)
            .filter(idx => !ignores.some(i => (0, databaseUtils_1.attributesRefSame)(i, { ...(0, databaseUtils_1.entityToRef)(idx.entity), attrs: idx.index.attrs })))
            .map(i => {
            const entity = (0, databaseUtils_1.entityToRef)(i.entity);
            const indexName = `${i.index.name ? i.index.name + ' ' : ''}on ${(0, databaseUtils_1.attributesRefToId)({ ...entity, attrs: i.index.attrs })}`;
            const message = `Index ${indexName} can be deleted, it's covered by: ${i.coveredBy.map(by => `${by.name || ''}(${by.attrs.map(databaseUtils_1.attributePathToId).join(', ')})`).join(', ')}.`;
            const { stats, extra, ...index } = i.index;
            const coveredBy = i.coveredBy.map(({ stats, extra, ...index }) => index);
            return { ruleId, ruleName, ruleLevel: conf.level, message, entity, attribute: i.index.attrs[0], extra: { index, coveredBy } };
        });
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/IndexDuplicated.elm
function getDuplicatedIndexes(entity) {
    const indexes = (entity.indexes || [])
        .filter(i => !i.attrs.some(a => a[0] === 'unknown' || a[0] === '*expression*')) // ignore indexes with expressions
        .sort((a, b) => (a.attrs.length - b.attrs.length) || (a.attrs.join(',').localeCompare(b.attrs.join(','))));
    return findDuplicated(entity, indexes);
}
function findDuplicated(entity, indexes, duplicates = []) {
    const [index, ...tail] = indexes;
    if (tail.length > 0) {
        const indexAttrs = index.attrs.map(databaseUtils_1.attributePathToId);
        const coveredBy = tail.filter(index => indexAttrs.every((a, i) => a === (0, databaseUtils_1.attributePathToId)(index.attrs[i])));
        if (coveredBy.length > 0) {
            return findDuplicated(entity, tail, duplicates.concat([{ entity, index, coveredBy }]));
        }
        else {
            return findDuplicated(entity, tail, duplicates);
        }
    }
    else {
        return duplicates;
    }
}
//# sourceMappingURL=indexDuplicated.js.map